var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 30,
    viewBox: "0 0 32 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 15C32 15.3758 31.85 15.7114 31.55 16.0067L17.7635 29.5772C17.4635 29.8591 17.1294 30 16.7612 30C16.3794 30 16.0589 29.8725 15.7998 29.6175C15.5544 29.3758 15.4317 29.0738 15.4317 28.7114C15.4317 28.5235 15.4589 28.3423 15.5135 28.1678C15.568 27.9933 15.6567 27.8524 15.7794 27.745L21.9363 21.6242L28.9113 15.2617L29.2386 16.0671L23.2045 16.349H1.35001C0.954555 16.349 0.627279 16.2215 0.368186 15.9664C0.122729 15.7114 0 15.3893 0 15C0 14.6107 0.122729 14.2886 0.368186 14.0336C0.627279 13.7785 0.954555 13.651 1.35001 13.651H23.2045L29.2386 13.9329L28.9113 14.7584L21.9363 8.37584L15.7794 2.25503C15.6567 2.13423 15.568 1.99329 15.5135 1.83221C15.4589 1.65772 15.4317 1.47651 15.4317 1.28859C15.4317 0.926175 15.5544 0.624161 15.7998 0.38255C16.0589 0.127517 16.3794 0 16.7612 0C16.9521 0 17.1362 0.0402685 17.3135 0.120805C17.4908 0.187919 17.6749 0.322148 17.8658 0.52349L31.55 13.9933C31.85 14.2752 32 14.6107 32 15Z",
    fill: "#03122E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/Arrow.b03763b60f55157952c33fdf8ee26c1c.svg";
export { ForwardRef as ReactComponent };